document.addEventListener('DOMContentLoaded', function() {
  var upsellModal = document.getElementById('upsell-modal');
  var close = document.getElementsByClassName('close')[0];
  var noThanks = document.getElementsByClassName('no-thanks')[0];
  var addToCartForm = document.querySelector('[data-type="add-to-cart-form"]');

  if (addToCartForm) {
    addToCartForm.addEventListener('submit', function(event) {
      if (upsellModal) {
        event.preventDefault();
        setTimeout(function() {
          upsellModal.style.display = "block";
        }, 100);

        var mainProductId = document.querySelector('select[name="id"]').value;
        addToCart(mainProductId, 1);  // Assuming a quantity of 1 for the main product
      }
    });
  } else {
    console.log("Add to Cart form not found!");
  }

  close.onclick = function() {
    upsellModal.style.display = "none";
    location.reload();
  }

  noThanks.onclick = function() {
    window.location.href = '/cart';
  }

  window.onclick = function(event) {
    if (event.target == upsellModal) {
      upsellModal.style.display = "none";
    }
  }

  var addToCartButtons = Array.from(document.getElementsByClassName('add-upsell'));

  addToCartButtons.forEach(function(button) {
    button.addEventListener('click', function(event) {
      var productId = event.target.dataset.productId;
      var quantity = 1;
      var quantityInput = event.target.closest('.quantity-true').querySelector('.quantity__input');

      if (quantityInput) {
        quantity = parseInt(quantityInput.value);
      }

      addToCart(productId, quantity, event);
    });
  });

  function addToCart(productId, quantity, event) {
    console.log("Attempting to add product with id:", productId, "and quantity:", quantity);
    return jQuery.post('/cart/add.js', {
      quantity: quantity,
      id: productId
    })
    .done(function() {
      event.target.textContent = '✓ Added to Cart';
      event.target.style.backgroundColor = "green";
      document.querySelector('.no-thanks').textContent = 'Continue';
      document.querySelector('.no-thanks').style.backgroundColor = "white";
    })
    .fail(function() {
      console.error('Failed to add product to cart');
    });
  }
});
